<template>
  <DiscountManagement
    btnText="新增代金券"
    :activity="6"
    childRoute="addNewCoupon"
  />
</template>
<script>
import DiscountManagement from '../Components/DiscountManagement'

export default {
  name: 'voucher',
  components: {
    DiscountManagement
  }
}
</script>
